<template>
  <div class="container-xl cooperation-content h-75">
    <div
      v-if="screenWidth >= 992"
      class="cooperation-content-title d-flex align-items-end"
      :class="tilteAnimate"
    >
      <div class="d-flex">
        <div class="colon"></div>
        <div class="cooperation-content-title-icon page-title">商务合作</div>
      </div>
      <span class="words opacity-1 mb-1">轻松五步快速开站</span>
    </div>
    <div v-if="screenWidth >= 769">
      <div class="form-row align-items-center justify-content-between">
        <div class="col">
          <div class="cooperation-step cooperation-step1"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
          }"
          ></div>
        </div>
        <div class="col">
          <div class="cooperation-line"></div>
        </div>
        <div class="col">
          <div class="cooperation-step cooperation-step2"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
            'animate__delay-1s':slideData === 'cooperation'
          }"
          ></div>
        </div>
        <div class="col">
          <div class="cooperation-line"></div>
        </div>
        <div class="col">
          <div class="cooperation-step cooperation-step3"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
            'animate__delay-2s':slideData === 'cooperation'
          }"
          ></div>
        </div>
        <div class="col">
          <div class="cooperation-line"></div>
        </div>
        <div class="col">
          <div class="cooperation-step cooperation-step4"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
            'animate__delay-3s':slideData === 'cooperation'
          }"
          ></div>
        </div>
        <div class="col">
          <div class="cooperation-line"></div>
        </div>
        <div class="col">
          <div class="cooperation-step cooperation-step5"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
            'animate__delay-4s':slideData === 'cooperation'
          }"
          ></div>
        </div>
      </div>
      <div class="form-row align-items-center">
        <div class="col">
          <div class="mt-4 cooperation-words"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
          }"
          >
            <span class="cooperation-words-number words opacity-1"> 01 </span>
            <span class="cooperation-words-data words">意向需求洽谈</span>
          </div>
        </div>
        <div class="col"></div>
        <div class="col">
          <div class="mt-4 cooperation-words"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
            'animate__delay-1s':slideData === 'cooperation'
          }"
          >
            <span class="cooperation-words-number words opacity-1"> 02 </span>
            <span class="cooperation-words-data words">签订合作协议</span>
          </div>
        </div>
        <div class="col"></div>
        <div class="col">
          <div class="mt-4 cooperation-words"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
            'animate__delay-2s':slideData === 'cooperation'
          }"
          >
            <span class="cooperation-words-number words opacity-1"> 03 </span>
            <span class="cooperation-words-data words">建站细节沟通</span>
          </div>
        </div>
        <div class="col"></div>
        <div class="col">
          <div class="mt-4 cooperation-words"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
            'animate__delay-3s':slideData === 'cooperation'
          }"
          >
            <span class="cooperation-words-number words opacity-1"> 04 </span>
            <span class="cooperation-words-data words">平台站点部署</span>
          </div>
        </div>
        <div class="col"></div>
        <div class="col">
          <div class="mt-4 cooperation-words"
          :class="{
            'animate__animated':slideData === 'cooperation',
            'animate__pulse':slideData === 'cooperation',
            'animate__delay-4s':slideData === 'cooperation'
          }"
          >
            <span class="cooperation-words-number words opacity-1"> 05 </span>
            <span class="cooperation-words-data words">正式上线运营</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="">
        <div class="mb-2 d-flex justify-content-center align-items-center">
          <div class="mr-3 cooperation-step cooperation-step1"></div>
          <div class="cooperation-words">
            <span class="cooperation-words-number words opacity-1"> 01 </span>
            <span class="cooperation-words-data words">意向需求洽谈</span>
          </div>
        </div>
        <div class="mb-2 d-flex justify-content-center align-items-center">
          <div class="mr-3 cooperation-step cooperation-step2"></div>
          <div class="cooperation-words">
            <span class="cooperation-words-number words opacity-1"> 02 </span>
            <span class="cooperation-words-data words">签订合作协议</span>
          </div>
        </div>
        <div class="mb-2 d-flex justify-content-center align-items-center">
          <div class="mr-3 cooperation-step cooperation-step3"></div>
          <div class="cooperation-words">
            <span class="cooperation-words-number words opacity-1"> 03 </span>
            <span class="cooperation-words-data words">建站细节沟通</span>
          </div>
        </div>
        <div class="mb-2 d-flex justify-content-center align-items-center">
          <div class="mr-3 cooperation-step cooperation-step4"></div>
          <div class="cooperation-words">
            <span class="cooperation-words-number words opacity-1"> 04 </span>
            <span class="cooperation-words-data words">平台站点部署</span>
          </div>
        </div>
        <div class="mb-2 d-flex justify-content-center align-items-center">
          <div class="mr-3 cooperation-step cooperation-step5"></div>
          <div class="cooperation-words">
            <span class="cooperation-words-number words opacity-1"> 05 </span>
            <span class="cooperation-words-data words">正式上线运营</span>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <div class="cooperation-content-footer"></div>
      <div class="cooperation-divider"><i></i></div>
      <div class="cooperation-subtitle">
        <span class="cooperation-subtitle-text">商务团队为您服务</span>
      </div>
    </div>
    <div class="cooperation-contact">
      <a class="cooperation-contact-item" :href="contact.tgLink" target="_blank" rel="noopener">
        <div class="cooperation-contact-icon">
          <svg viewBox="3.1 -0.5 24 24" aria-hidden="true">
            <path d="M21.4 3.2 2.9 10.4c-.8.3-.8 1.4 0 1.7l5.6 1.9 2.2 6.3c.3.8 1.3.9 1.8.3l2.4-3 4.4 3.3c.6.4 1.4.1 1.6-.6l3-15.1c.2-.9-.7-1.6-1.5-1.3Z"/>
            <path class="fold" d="M8.5 14 18.6 6.2 11.2 15.4l-.5 4.9Z"/>
          </svg>
        </div>
        <div class="cooperation-contact-title">Telegram</div>
        <div class="cooperation-contact-desc">即时商务洽谈</div>
        <div class="cooperation-contact-value">{{ contact.tgName }}</div>
      </a>
      <div class="cooperation-contact-sep"></div>
      <a class="cooperation-contact-item" :href="`mailto:${contact.email}`">
        <div class="cooperation-contact-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M3.5 5h17c.8 0 1.5.7 1.5 1.5v.3l-10 6.4L2 6.8v-.3C2 5.7 2.7 5 3.5 5Zm-1.5 4.2 9.5 6c.3.2.7.2 1 0l9.5-6v8.3c0 .8-.7 1.5-1.5 1.5h-17c-.8 0-1.5-.7-1.5-1.5V9.2Z"/>
          </svg>
        </div>
        <div class="cooperation-contact-title">E-mail</div>
        <div class="cooperation-contact-desc">商务合作信箱</div>
        <div class="cooperation-contact-value">{{ contact.email }}</div>
      </a>
    </div>
    <div class="cooperation-qr">
      <a class="cooperation-qr-frame" :href="contact.tgLink" target="_blank" rel="noopener">
        <img src="@/assets/images/footer/dddngo8-TG.png" alt="Telegram @dddngo8 QR code">
      </a>
      <div class="cooperation-qr-caption">扫码联系 Telegram</div>
    </div>
  </div>
</template>

<script>
import { getContactId } from '../../utils/query-string';

export default {
  name: 'Index',
  props: {
    slideData: {
      type: String,
      required: true
    },
    screenWidth: {
      type: Number,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
      id: getContactId(),
      telegram: '',
      skype: '',
      contact: {
        tgName: '@dddngo8',
        tgLink: 'https://t.me/dddngo8',
        email: 'dng@doing.social',
      },
    }
  },
  computed: {
    tilteAnimate() {
      return {
        'animate__animated': this.slideData === 'cooperation',
        'animate__lightSpeedInLeft': this.slideData === 'cooperation',
        'opacity-0':this.slideData !== 'cooperation',
        'opacity-1':this.slideData === 'cooperation'
      }
    }
  },
  mounted () {

      if (!this.id){
        return
      }
      fetch('/contact.json')
      .then(res=>res.json())
      .then(res=>{
        const info = res.find(e=>e.id == this.id);

        if(!info){
          return
        }
        this.telegram = info.tg
        this.skype = info.skype
      })
  },
  methods:{
    open:(link) => {
      if(!link) return
      link && window.open(link,'_blank')
    }
  }
};
</script>

<style lang="scss" scoped>
  .animate__animated.animate__pulse.animate__delay-1s {
    --animate-delay: 0.4s;
  }
  .animate__animated.animate__pulse.animate__delay-2s {
    --animate-delay: 0.4s;
  }
  .animate__animated.animate__pulse.animate__delay-3s {
    --animate-delay: 0.4s;
  }
  .animate__animated.animate__pulse.animate__delay-4s {
    --animate-delay: 0.4s;
  }
</style>

